import { GridColumnType } from "../../../data/gridColumnType";

export const InvoiceApprovalConfig = {
  columns: [
    {
      name: "",
      fieldName: "checkbox",
      allowShort: false,
      colType: GridColumnType.CHECKBOX,
    },
    {
      name: "Company Name",
      fieldName: "companyName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Approver Name",
      fieldName: "approverName",
      colType: GridColumnType.Text,
    },
    {
      name: "Cert Number",
      fieldName: "certNumber",
      colType: GridColumnType.Text,
    },
    {
      name: "Overseas",
      fieldName: "overseas",
      colType: GridColumnType.Text,
    },
    {
      name: "Country",
      fieldName: "country",
      colType: GridColumnType.Text,
    },
    {
      name: "Push to Xero",
      fieldName: "pushToXero",
      colType: GridColumnType.Text,
    },
    {
      name: "Manual Invoice Number",
      fieldName: "manualInvoiceNumber",
      colType: GridColumnType.Text,
    },
  ],
};
